
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { AtSign, MessageCircle } from 'lucide-react';
import { useUnifiedNotifications } from '@/hooks/useUnifiedNotifications';
import { useUnifiedUser } from '@/hooks/useUnifiedUser';
import { useNavigate } from 'react-router-dom';
import { highlightMentions } from '@/utils/mentionUtils';

const MentionsView = () => {
  const { notifications, markAsRead } = useUnifiedNotifications();
  const { user } = useUnifiedUser();
  const navigate = useNavigate();

  // Filter for mentions only
  const mentions = notifications.filter(notif => notif.type === 'mention');

  console.log('=== MENTIONS VIEW ===');
  console.log('Total notifications:', notifications.length);
  console.log('Total mentions:', mentions.length);
  console.log('Current user:', user?.username);

  const handleMentionClick = (mention: any) => {
    markAsRead(mention.id);
    navigate('/chat');
  };

  if (mentions.length === 0) {
    return (
      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-white">
            <AtSign className="h-5 w-5 text-sports-green" />
            Your Mentions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <AtSign className="h-12 w-12 mx-auto text-gray-400 mb-4" />
            <p className="text-gray-400">No mentions yet</p>
            <p className="text-sm text-gray-500 mt-1">
              When someone mentions you with @{user?.username}, it will appear here
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-gray-800 border-gray-700">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-white">
          <AtSign className="h-5 w-5 text-sports-green" />
          Your Mentions ({mentions.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <ScrollArea className="h-96">
          <div className="p-4 space-y-3">
            {mentions.map((mention) => (
              <div
                key={mention.id}
                onClick={() => handleMentionClick(mention)}
                className={`p-4 rounded-lg border cursor-pointer transition-colors ${
                  mention.is_read 
                    ? 'bg-gray-700/50 border-gray-600 hover:bg-gray-700'
                    : 'bg-sports-green/10 border-sports-green/30 hover:bg-sports-green/20'
                }`}
              >
                <div className="flex items-start gap-3">
                  <MessageCircle className="h-5 w-5 text-sports-green flex-shrink-0 mt-1" />
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="font-medium text-white">
                        {mention.from_username}
                      </p>
                      <span className="text-sm text-gray-400">
                        in {mention.chat_group_name}
                      </span>
                      {!mention.is_read && (
                        <div className="w-2 h-2 bg-sports-green rounded-full"></div>
                      )}
                    </div>
                    
                    <div className="text-sm text-gray-300 mb-2">
                      {highlightMentions(mention.message_preview, user?.username)}
                    </div>
                    
                    <p className="text-xs text-gray-500">
                      {formatDistanceToNow(new Date(mention.created_at), { addSuffix: true })}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default MentionsView;
